import React from 'react';
import { twMerge } from 'tailwind-merge';
type SectionHeadingProps = {
  title: string;
  subtitle?: string;
  tone?: 'light' | 'dark';
  className?: string;
};

/** Centered section title with the gold rule used across the site. */
export function SectionHeading({
  title,
  subtitle,
  tone = 'light',
  className
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <div className={twMerge('text-center', className)} data-id="element-141" data-mp="myeou8ff5b0c">
      <h2 className={twMerge('font-display text-2xl font-semibold uppercase tracking-wide sm:text-3xl', isDark ? 'text-white' : 'text-night-900')} data-id="element-142" data-mp="mzzhfsi6ajvk">
        {title}
      </h2>
      <div className="mx-auto mt-3 h-px w-24 bw-gold-rule" aria-hidden="true" data-id="element-143" data-mp="d6imuma7p0qu" />
      {subtitle && <p className={twMerge('mx-auto mt-4 max-w-xl text-[14px] leading-relaxed sm:text-[15px]', isDark ? 'text-white/60' : 'text-muted')} data-id="element-144" data-mp="87xq4wu64z75">
          {subtitle}
        </p>}
    </div>;
}